import { render, staticRenderFns } from "./new-user-guide.vue?vue&type=template&id=6fe61e52&scoped=true&"
import script from "./new-user-guide.vue?vue&type=script&lang=js&"
export * from "./new-user-guide.vue?vue&type=script&lang=js&"
import style0 from "./new-user-guide.vue?vue&type=style&index=0&id=6fe61e52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe61e52",
  null
  
)

export default component.exports